import { styled } from "styled-components"

interface ButtonColorsType {
  $bgColor?: string
  $borderColor?: string
  $hoverColor?: string
  $activeColor?: string
  $textColor?: string
  $activeTextColor?: string
  $size?: "small" | "large"
  $shadow?: boolean
}

const StyledButton = styled.button<ButtonColorsType>`
  box-sizing: border-box;
  border-radius: ${(props) => (props.$size === "small" ? "15px" : "20px")};
  border-width: ${(props) => (props.$size === "small" ? "1px" : "2px")};
  border-style: solid;
  border-color: ${(props) =>
    props.$borderColor ? props.$borderColor : "var(--custom-blue)"};
  width: 100%;
  height: ${(props) =>
    props.$size === "small"
      ? "30px"
      : props.$size === "large"
      ? "45px"
      : "40px"};
  background-color: ${(props) =>
    props.$bgColor ? props.$bgColor : "var(--custom-white-smoke)"};
  box-shadow: ${(props) =>
    props.$shadow ? "1px 1px 2px 3px rgba(45, 39, 17, 0.1)" : "none"};
  text-align: center;
  line-height: ${(props) =>
    props.$size === "small"
      ? "28px"
      : props.$size === "large"
      ? "41px"
      : "36px"};
  font-size: ${(props) => (props.$size === "large" ? "20px" : "15px")};
  font-weight: ${(props) => (props.$size === "small" ? "medium" : "bold")};
  color: ${(props) =>
    props.$textColor ? props.$textColor : "var(--custom-deep-dark-brown)"};
  cursor: pointer;

  transition: all 0.2s ease;

  &:active {
    background-color: ${(props) =>
      props.$activeColor ? props.$activeColor : "var(--custom-blue)"};
    color: ${(props) =>
      props.$activeTextColor
        ? props.$activeTextColor
        : "var(--custom-white-smoke)"};
  }

  &:hover {
    background-color: ${(props) =>
      props.$hoverColor ? props.$hoverColor : "var(--custom-light-blue)"};
    color: ${(props) =>
      props.$activeTextColor
        ? props.$activeTextColor
        : "var(--custom-white-smoke)"};
    box-shadow: ${(props) =>
      props.$shadow ? "2px 2px 4px 3px rgba(45, 39, 17, 0.25)" : "none"};
  }

  &:disabled {
    color: var(--custom-silver);
    border-color: var(--custom-platinum);
    pointer-events: none;
  }
`

const TwoColumnGrid = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px 40px;
`

const LargeHeightButton = styled.div<ButtonColorsType>`
  border: ${(props) =>
    `2px solid ${
      props.$borderColor ? props.$borderColor : "var(--custom-blue)"
    }`};
  border-radius: 20px;
  box-sizing: border-box;

  width: 400px;
  height: 110px;

  background-color: ${(props) =>
    props.$bgColor ? props.$bgColor : "var(--custom-white-smoke)"};
  color: #ffffff;
  font-size: 20px;
  text-align: left;

  padding-top: 25px;
  padding-left: 25px;

  cursor: pointer;
  transition: box-shadow 0.3s;

  &:active {
    background-color: ${(props) =>
      props.$activeColor ? props.$activeColor : "var(--custom-blue)"};
    color: ${(props) =>
      props.$activeTextColor
        ? props.$activeTextColor
        : "var(--custom-white-smoke)"};
    transform: scale(1.02, 1.05);
  }

  &:hover {
    background-color: ${(props) =>
      props.$hoverColor ? props.$hoverColor : "var(--custom-light-blue)"};
    color: ${(props) =>
      props.$activeTextColor
        ? props.$activeTextColor
        : "var(--custom-white-smoke)"};
    transform: scale(1.02, 1.05);
    box-shadow: ${(props) =>
      props.$shadow ? "2px 2px 4px 3px rgba(45, 39, 17, 0.25)" : "none"};
  }

  .desc {
    font-size: 12px;
    margin-top: 5px;
    padding: 0 3px;
    color: #c4c4c4;
  }
`

export { StyledButton, TwoColumnGrid, LargeHeightButton }
